import { call, put, takeLatest } from "redux-saga/effects"
import { GET_EVOLUTION_MEASURE_WATCHER } from "./constants"
import {
  getEvolutionMeasureFailed,
  getEvolutionMeasureSuccess,
} from "./actions"
import api from "../../../utils/api"
import { TYPE_FETCHING } from "../../../utils/constants"
import { validate } from "../../../utils/functions"

function getEvolutionMeasureApi(payload) {
  const segmentParam = !validate.empty(payload.id_segment)
    ? `&id_segment=${payload.id_segment}`
    : ""
  return api(
    `reports/measure/${payload.idMeasure}/evolution?f${segmentParam}`,
    TYPE_FETCHING.get,
    { id_division: payload.idDivision, id_segment: payload.idSegment }
  )
}

export function* getEvolutionMeasureSaga(action) {
  try {
    const evolutionData = yield call(
      getEvolutionMeasureApi,
      action.payload
    )
    yield put(getEvolutionMeasureSuccess(evolutionData))
  } catch (e) {
    yield put(getEvolutionMeasureFailed())
  }
}

export default function* widgetResumeSaga() {
  yield takeLatest(GET_EVOLUTION_MEASURE_WATCHER, getEvolutionMeasureSaga)
}
